export default "__VITE_ASSET__BGMFIdzL__"